export class RoleMetadata {
  id: number;
  roleId: string;
  roleNameId: string;
  roleDisplayName: string;
  isExternal: boolean;
  onlyShowSelfUploadedFiles: boolean;
  isActive: boolean;
}
